import React from 'react';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';



import * as actions from '../../actions/index';
import { Row, Col, Form, Input, Select, Tooltip, Icon, Card, Checkbox } from 'antd';
import { first } from 'lodash';

const { Option } = Select;
const { Item: FormItem } = Form;


const ScoutsPrimaryOrAlternateAddress = (props) => {

  const {firstName = '', lastName = ''} = props.selectedRecord;
  const {isRedirectedFromGift = false } = props;

  const primaryHomeAddress = isRedirectedFromGift ?  'Eagle Scout\'s Primary Home Address' : 'Your Primary Home Address';
  const alternateShippingAddress = isRedirectedFromGift ?  "Eagle Scout\'s Alternate 'Ship to' Address" : "Your Alternate 'Ship to' Address";

  let addressFrameTitle = ''
    if(isRedirectedFromGift) addressFrameTitle = alternateShippingAddress;
    else addressFrameTitle = props.isShippingAddress ? alternateShippingAddress : primaryHomeAddress;

  // const renderPhoneCountryId = () => {
  //   if (props.phonecode) {
  //     let phonecode = props.phonecode.sort((a, b) => a.name.localeCompare(b.name))
  //     return phonecode.map((k, index) => {
  //       return (
  //         <option key={index} value={k.id}>{k.name}</option>
  //       )
  //     })
  //   }
  // }

  const renderPhoneCountryId = () => {
    if (props.phonecode) {
      const phonecode = props.phonecode.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      return phonecode.map((k) => (
        <Option key={k.id} value={`${k.id}`}>
          {k.name}
        </Option>
      ));
    }

    return null;
  };

  // const renderStatesID = () => {
  //   if (props.allstates) {
  //     let statesarray = props.allstates
  //     return statesarray.map((k, index) => {
  //       return (
  //         <option key={index} value={k.id}>{k.short}</option>
  //       )
  //     })
  //   }
  // }

  const renderStatesID = () => {
    if (props.allstates) {
      return props.allstates.map((k) => (
        <Option key={k.id} value={`${k.id}`}>
          {k.short}
        </Option>
      ));
    }

    return null;
  };

  // const renderCountryId = () => {
  //   if (props.countriesCode) {
  //     let countriesCode = props.countriesCode.sort((a, b) => a.name - b.name)
  //     return countriesCode.map((k, index) => {
  //       return (
  //         <option key={index} value={k.id}>{k.name}</option>
  //       )
  //     })
  //   }
  // }

  const renderCountryId = () => {
    if (props.countriesCode) {
      const countriesCode = [...props.countriesCode].sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      return countriesCode.map((k) => (
        <Option key={k.id} value={`${k.id}`}>
          {k.name}
        </Option>
      ));
    }

    return null;
  };

  const USAAddressForm = ({ form }) => {

    const { getFieldDecorator } = form;
    const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };
    

    return (
      <Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
        <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem
              label={isRedirectedFromGift ? 'Scout\'s First Name' :  "First Name"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsFirstName' : 'firstName', {
                initialValue: firstName,
                rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s First Name!' : 'Enter Your First Name!' }],
              })(
                <Input disabled={Boolean(firstName)} placeholder={isRedirectedFromGift ? 'Scout\'s First Name' :  "First Name"} />
              )}
            </FormItem>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem
              label={isRedirectedFromGift ? 'Scout\'s Last Name' : "Last Name"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsLastName' : 'lastName', {
                initialValue: lastName,
                rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Last Name!' : 'Enter Your Last Name!' }],
              })(
                <Input disabled={Boolean(lastName)} placeholder={isRedirectedFromGift ? 'Scout\'s Last Name' : "Last Name"} />
              )}
            </FormItem>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? "Scout\'s Phone" : "Phone"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsPhone' : 'phone', {
                rules: [
                  { required:
                    props.form.getFieldValue(
                      isRedirectedFromGift ? 'ScoutsCountryId' : 'countryId'
                    ) != 616,
                    min: 4, max: 10, message: isRedirectedFromGift ? 'Enter Scout\'s Phone Number!' : 'Enter Your Phone Number!' },
                { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
              })(
                <Input
                  addonBefore={
                    getFieldDecorator(isRedirectedFromGift ? 'ScoutsPhonecountryID' : 'phonecountryID', {
                      rules: [
                        { required: !isRedirectedFromGift,
                         message: isRedirectedFromGift ? 'Select Scout\'s Phone Country ID' : 'Select Phone Country ID' 
                        }
                      ],
                      initialValue: '636'
                    })(
                      <Select style={{ width: 120 }}  >
                        {/* Replace getPhoneCode() with your actual implementation */}
                        {renderPhoneCountryId()}
                      </Select>
                    )
                  }
                  placeholder={isRedirectedFromGift ? "Scout\'s Phone" : "Phone"}
                />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s Email' : "Email"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsEmail' : 'email', {
                rules: [
                  { required: true,
                   type: "email", 
                message: isRedirectedFromGift ? 'Enter a valid Scout\'s Email' : 'Enter valid email address!' 
              }
            ]
              })(
                <Input placeholder={isRedirectedFromGift ? 'Scout\'s Email' : "Email"} />
              )}
            </FormItem>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem
              label={isRedirectedFromGift ? 'Scout\'s Country' : "Country"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsCountryId' : 'countryId', {
                initialValue: "616",
                rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Country' : 'Enter Your Country!' }],
              })(
                <Select
                  showAction={['focus', 'click']}
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Select a Country"
                  optionFilterProp="children"
                  onChange={(e) => {
                    props.changeScoutsCountryEventHandler(e);

                    const phoneField = isRedirectedFromGift ? 'ScoutsPhone' : 'phone';

                    if (String(e) === '616') {
                      props.form.setFields({
                        [phoneField]: {
                          value: props.form.getFieldValue(phoneField),
                          errors: undefined,
                        },
                      });
                    } else {
                      props.form.validateFields([phoneField], { force: true });
                    }
                  }}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {renderCountryId()}
                </Select>
              )}
            </FormItem>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s Address Line 1' : "Address Line 1"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsAddressline1' : 'addressline1', {
                rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Address Line 1!' : 'Enter Your Address!' }],
              })(
                <Input placeholder={isRedirectedFromGift ? 'Scout\'s Address Line 1' : "Address Line 1"} />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s Address Line 2' : "Address Line 2"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsAddressline2' : 'addressline2', {
                rules: [{ required: false, message: isRedirectedFromGift ? 'Enter Scout\'s Address Line 2!' : 'Enter Your Address!' }],
              })(
                <Input placeholder={isRedirectedFromGift ? 'Scout\'s Address Line 2' : "Address Line 2"} />
              )}
            </FormItem>
          </Col>

          { /* Hiding Addressline 3 as per changes from AAG-1026
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 3"
                    >
                        {getFieldDecorator('addressline3', {
                            // initialValue: state.selectedRecord.address3 ? state.selectedRecord.address3 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 3"
                            // className={state.selectedRecord.address3 ? 'input-disabled' : ''}
                            // disabled={state.selectedRecord.address3 ? true : false} 
                            />
                        )}
                    </FormItem>
                        </Col> */}

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s City' : "City"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsCity' : 'city', {
                rules: [{ required: true, min: 2, message: isRedirectedFromGift ? 'Enter Scout\'s City' : 'Enter Your City!' }],
              })(
                <Input placeholder={isRedirectedFromGift ? 'Scout\'s City' : "City"} />
              )}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s State' : "State"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsState' : 'state', {
                rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s State!' : 'Enter Your State!' }],
              })(
                <Select
                  // disabled={state.selectedRecord.stateId ? true : false}
                  getInputElement={stateInputEle}
                  showAction={['focus', 'click']}
                  showSearch
                  style={{ width: '100%', textTransform: 'uppercase' }}
                  placeholder="Select a State"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {renderStatesID()}
                </Select>
              )}
            </FormItem>
          </Col>


        </Row>

        <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s Zip Code' : "ZIP Code"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsZipcode' : 'zipcode', {
                rules: [{ required: true, max: 5, message: isRedirectedFromGift ? 'Enter Scout\'s Zip Code!' : 'Enter Your ZIP Code!' }],
              })(
                <Input placeholder={isRedirectedFromGift ? 'Scout\'s Zip Code' : "ZIP Code"} maxLength={5} />
              )}
            </FormItem>
          </Col>

          {/* Additional Rows and FormItems go here */}

        </Row>
      </Row>
    );
  }

  const render_nonUSA_address = () => {

    const { getFieldDecorator } = props.form;
    const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

    return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
      <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem
            label={isRedirectedFromGift ? 'Scout\'s First Name' :  "First Name"}
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsFirstName' : 'firstName', {
              initialValue: firstName,
              rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s First Name' : 'Enter Your First Name!' }],
            })(
              <Input disabled={Boolean(firstName)} placeholder={isRedirectedFromGift ? 'Scout\'s First Name' :  "First Name"} />
            )}
          </FormItem>
        </Col>

        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem
            label={isRedirectedFromGift ? 'Scout\'s Last Name' : "Last Name"}
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsLastName' : 'lastName', {
              initialValue: lastName,
              rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Last Name' : 'Enter Your Last Name!' }],
            })(
              <Input disabled={Boolean(lastName)} placeholder={isRedirectedFromGift ? 'Scout\'s Last Name' : "Last Name"} />
            )}
          </FormItem>
        </Col>


          {/* //AAG-1026 ADDED BACK - 'Scout\'s Phone Number from NESA application process */}
          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem hasFeedback
            label={isRedirectedFromGift ? "Scout\'s Phone" : "Your Phone"}
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsPhone' : 'phone', {
              // initialValue: state.selectedRecord.phone ? (state.PhoneNumber) ? state.PhoneNumber.toString() : state.selectedRecord.phone.toString() : '',
              rules: [{ required:
                      props.form.getFieldValue(
                        isRedirectedFromGift ? 'ScoutsCountryId' : 'countryId'
                      ) != 616,
                      min: 4, max: 10, message: isRedirectedFromGift ? 'Enter Scout\'s Phone Number!' : 'Enter Your Phone Number!' },
              {
                pattern: new RegExp("^[0-9]*$"),
                message: "Phone Number must be all numeric!"
              }],
            })(
              <Input
                // className={state.PhoneNumber ? 'input-disabled' : ''}
                // disabled={(state.PhoneNumber) ? true : false}
                addonBefore={
                  getFieldDecorator(isRedirectedFromGift ? 'ScoutsPhonecountryID' : 'phonecountryID', {
                    rules: [{ required: true, message: 'Select Phone Country ID' }],
                    initialValue: props.phoneCountryId ? `${props.phoneCountryId}` : "636",
                    // initialValue:  "636",
                  })(
                    <Select style={{ width: 120 }}
                    //  ref={selectphonecountryIDRef} onSelect={() => selectphonecountryIDRef.current.blur()}
                    >
                      {renderPhoneCountryId()}
                    </Select>
                  )
                } 
                  placeholder = {isRedirectedFromGift ? "Scout\'s Phone" : "Your Phone"}
                />
            )}
          </FormItem>
        </Col>

      </Row>

      <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
      
      <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem hasFeedback
            label={isRedirectedFromGift ? "Scout\'s Email" : "Your Email"}
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsEmail' : 'email', {
              // initialValue: state.selectedRecord.email ? state.selectedRecord.email : "",
              rules: [{ required: true, type: "email", 
              message: isRedirectedFromGift ? 'Enter a valid Scout\'s Email' : 'Enter valid email address!' }]
            })(
              <Input placeholder={isRedirectedFromGift ? 'Scout\'s Email' : "Email"}
              // disabled={state.selectedRecord.email ? true : false}
              // className={state.selectedRecord.email ? 'input-disabled' : ''}
              />
            )}
          </FormItem>
        </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem
            label={isRedirectedFromGift ? 'Scout\'s Country' : "Your Country"}
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsCountryId' : 'countryId', {
              initialValue: props.scoutsCountry ? `${props.scoutsCountry}` : "616",
              rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Country!' : 'Enter Your Country!' }],
            })(
              <Select
                // className={props.scoutsCountry ? 'input-disabled' : ''}
                // disabled={props.scoutsCountry ? true : false}
                showAction={['focus', 'click']}
                showSearch
                style={{ width: '100%' }}
                placeholder="Select a Country"
                optionFilterProp="children"
                onChange={(e) => {
                  props.changeScoutsCountryEventHandler(e);

                  const phoneField = isRedirectedFromGift ? 'ScoutsPhone' : 'phone';

                  if (String(e) === '616') {
                    props.form.setFields({
                      [phoneField]: {
                        value: props.form.getFieldValue(phoneField),
                        errors: undefined,
                      },
                    });
                  } else {
                    props.form.validateFields([phoneField], { force: true });
                  }
                }}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {renderCountryId()}
              </Select>
            )}
          </FormItem>
        </Col>

        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem hasFeedback
            label={(
              <span>
                {isRedirectedFromGift ? 'Scout\'s Address Line 1' : 'Address Line 1'}&nbsp;
                <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
                  <Icon type="info-circle-o" />
                </Tooltip>
              </span>
            )}
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsAddressline1' : 'addressline1', {
              // initialValue: state.selectedRecord.address1 ? state.selectedRecord.address1 : "",
              rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Address Line 1' : 'Enter Your Address!' }],
            })(
              <Input placeholder={isRedirectedFromGift ? 'Scout\'s Address Line 1' : "Address Line 1"}
              // className={state.selectedRecord.address1 ? 'input-disabled' : ''}
              // disabled={state.selectedRecord.address1 ? true : false}
              />
            )}
          </FormItem>
        </Col>

      </Row>

      <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
      <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem hasFeedback
            style={{ marginBottom: '0px' }}
            label={(
              <span>
                {isRedirectedFromGift ? 'Scout\'s Address Line 2': 'Address Line 2'}&nbsp;
                <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
                  <Icon type="info-circle-o" />
                </Tooltip>
              </span>
            )}
          //extra="City, Territory, Country"
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsAddressline2' : 'addressline2', {
              // initialValue: state.selectedRecord.address2 ? state.selectedRecord.address2 : "",
              rules: [{ required: false, message: isRedirectedFromGift ? 'Enter Scout\'s Address Line 2' : 'Enter Your Address!' }],
            })(
              <Input placeholder={isRedirectedFromGift ? 'Scout\'s Address Line 2' : "Address Line 2"}
              // className={state.selectedRecord.address2 ? 'input-disabled' : ''}
              // disabled={state.selectedRecord.address2 ? true : false} 
              />
            )}
          </FormItem>
        </Col>

        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <FormItem hasFeedback
            style={{ marginBottom: '0px' }}
            label={(
              <span>
                {isRedirectedFromGift ? 'Scout\'s Address Line 3': 'Address Line 3'}&nbsp;
                <Tooltip placement="top" title="List the city, territory and country according to country standards (Southampton, SO53 5PD, UK;">
                  <Icon type="info-circle-o" />
                </Tooltip>
              </span>
            )}
            extra="City, Territory, Country"
          >
            {getFieldDecorator(isRedirectedFromGift ? 'ScoutsAddressline3' : 'addressline3', {
              // initialValue: state.selectedRecord.address3 ? state.selectedRecord.address3 : "",
              rules: [{ required: true, message: isRedirectedFromGift ? 'Enter Scout\'s Address Line 3' : 'Enter Your Address!' }],
            })(
              <Input placeholder="Address Line 3"
              // className={state.selectedRecord.address3 ? 'input-disabled' : ''}
              // disabled={state.selectedRecord.address3 ? true : false} 
              />
            )}
          </FormItem>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} xl={8}>
            <FormItem hasFeedback
              label={isRedirectedFromGift ? 'Scout\'s Postal Code' : "Postal Code"}
            >
              {getFieldDecorator(isRedirectedFromGift ? 'ScoutsZipcode' : 'zipcode', {
                rules: [{ required: true, max: 10, message: isRedirectedFromGift ? 'Enter Scout\'s Zip Code!' : 'Enter Your ZIP Code!' }],
              })(
                <Input placeholder={isRedirectedFromGift ? 'Scout\'s Zip Code' : "ZIP Code"} maxLength={10} />
              )}
            </FormItem>
          </Col>

      </Row>

    </Row>
    )
  }



    const renderAddressFrames = () => {
     if(props.scoutsCountry == '616' || props.scoutsCountry == 616 || props.scoutsCountry == '')
     return USAAddressForm(props);
     else return render_nonUSA_address();
    }

    

  return (
    <div>
      <Card
        className="centered"
        title={addressFrameTitle}
      >
        {isRedirectedFromGift ? renderAddressFrames()
          :
          <div>
            {!props.isShippingAddress && renderAddressFrames()}
            {/* {addressInfo()} */}

            {isRedirectedFromGift ? null : <div className='margin-10'>
              <Checkbox
                onClick={(e) => props.changeAlternateShippingAddressEventHandler(e, 'confirmationBox')}
                className='ShippingAlternateCheckbox'
              >
                Alternate Shipping Address; Awards and Certificates will be shipped to your home address unless Alternate Shipping Address is selected.
              </Checkbox>

              {props.isShippingAddress && renderAddressFrames()}

            </div>}
          </div>
        }
      </Card>
    </div>
    //     )
    //  }
    //   {props.scoutsCountry == '616' || props.scoutsCountry == 616 || props.scoutsCountry == '' ? USAAddressForm(props) : render_nonUSA_address(props)}
    // </div>
  );
};

const mapStateToProps = (state) => ({
  phonecode: state.phonecountrycodereducer.code,
  countriesCode: state.countriesreducer.countries,
  allstates: state.allstatesreducer.states,
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(ScoutsPrimaryOrAlternateAddress)));



// WEBPACK FOOTER //
// ./src/components/Membership/ScoutsAddress.js